export default "__VITE_PUBLIC_ASSET__19a580d4__"